/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * RIGHTIO Address Lookups API - ASP.NET 8
 * The RIGHTIO Address Lookups API provides a robust and reliable service for accessing and retrieving address data. Built with ASP.NET 8, this API ensures that services requiring address data can do so with high efficiency and security, supporting the operational needs of the RIGHTIO platform.
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetAddressesByPostcodeParams,
  RightioPAFAPIModelsAddressLegacyDto,
  SystemVoid
} from '../../model';

import { customInstance } from '../../../../../services/PafDatabaseAccess/index';
import type { ErrorType } from '../../../../../services/PafDatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Retrieves addresses for a given postcode.
 */
export const getAddressesByPostcode = (
    params: GetAddressesByPostcodeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RightioPAFAPIModelsAddressLegacyDto[]>(
      {url: `/addresses`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetAddressesByPostcodeQueryKey = (params: GetAddressesByPostcodeParams,) => {
    return [`/addresses`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAddressesByPostcodeQueryOptions = <TData = Awaited<ReturnType<typeof getAddressesByPostcode>>, TError = ErrorType<SystemVoid>>(params: GetAddressesByPostcodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddressesByPostcode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesByPostcodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressesByPostcode>>> = ({ signal }) => getAddressesByPostcode(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddressesByPostcode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddressesByPostcodeQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressesByPostcode>>>
export type GetAddressesByPostcodeQueryError = ErrorType<SystemVoid>



export function useGetAddressesByPostcode<TData = Awaited<ReturnType<typeof getAddressesByPostcode>>, TError = ErrorType<SystemVoid>>(
 params: GetAddressesByPostcodeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddressesByPostcode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddressesByPostcodeQueryOptions(params,options)

  const query = useQuery(queryOptions ) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



